<template>
  <div>
    <v-container fluid grid-list-xl class="pl-0 pr-0" v-if="!isLoading">
      <v-layout wrap>
        <v-flex lg4 md6 xs12>
          <stat-widget icon="fal fa-hand-point-up" title="Clicks" :total="total.clicks | local_numbers" :predicted="predicted.clicks | local_numbers" :current="formattedData.clicks" :previous="formattedPreviousData.clicks"></stat-widget>
        </v-flex>
        <v-flex lg4 md6 xs12>
          <stat-widget icon="fal fa-fingerprint" title="Unique clicks" :total="total.unique_clicks | local_numbers" :predicted="predicted.unique_clicks | local_numbers" :current="formattedData.unique_clicks" :previous="formattedPreviousData.unique_clicks" :cpc="total.cpc"></stat-widget>
        </v-flex>
        <v-flex lg4 md6 xs12>
          <stat-widget icon="fal fa-shopping-basket" title="Sales" :total="total.sales | local_numbers" :predicted="predicted.sales | local_numbers" :conversion="total.conversion + '%'" :current="formattedData.sales" :previous="formattedPreviousData.sales"></stat-widget>
        </v-flex>
        <v-flex lg4 md6 xs12>
          <stat-widget icon="fal fa-money-bill-wave" title="Commission (excl. tax)" :total="total.commission | local_numbers" :predicted="predicted.commission | local_numbers" :current="formattedData.commission" :previous="formattedPreviousData.commission"></stat-widget>
        </v-flex>
        <v-flex lg4 md6 xs12>
          <stat-widget icon="fal fa-coins" title="Revenue (excl. tax)" :total="total.revenue | local_numbers" :predicted="predicted.revenue | local_numbers" :current="formattedData.revenue" :previous="formattedPreviousData.revenue" :roi="total.roi"></stat-widget>
        </v-flex>
        <v-flex xs12 sm6 v-if="topInfluencers.length > 0">
          <v-card>
            <v-card-title><div class="headline">Top influencers</div></v-card-title>
            <v-card-text>
              <v-data-table hide-default-footer :headers="[{ text: 'Influencer', value: 'name' }, { text: 'Clicks', value: 'clicks' }, { text: 'Sales', value: 'sales' }]" :items="topInfluencers" :items-per-page="10000">
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.uuid">
                      <td>
                        <router-link :to="{ name: 'influencer', params: { id: item.uuid } }">
                          {{ item.name || item.display_name }}
                        </router-link>
                      </td>
                      <td>{{ item.clicks }}</td>
                      <td>{{ item.sales }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 v-if="topBusinesses.length > 0">
          <v-card>
            <v-card-title><div class="headline">Top brands</div></v-card-title>
            <v-card-text>
              <v-data-table hide-default-footer :headers="[{ text: 'Brand', value: 'name' }, { text: 'Clicks', value: 'clicks' }, { text: 'Sales', value: 'sales' }]" :items="topBusinesses" :items-per-page="10000">
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.uuid">
                      <td>
                        <router-link :to="{ name: 'business', params: { id: item.uuid } }">
                          {{ item.name || item.display_name }}
                        </router-link>
                      </td>
                      <td>{{ item.clicks }}</td>
                      <td>{{ item.sales }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-flex class="d-flex flex-wrap pt-2" v-else>
      <v-flex lg4 md6 xs12 v-for="(item, k) in 6" :key="`a-${k}`">
        <v-card class="p-2 m-2">
          <v-skeleton-loader type="list-item-avatar" class="mb-3"></v-skeleton-loader>
          <v-skeleton-loader class="rounded" width="100%" type="image"></v-skeleton-loader>
        </v-card>
      </v-flex>
      <v-flex lg6 md6 xs12 v-for="(item, k) in 2" :key="`b-${k}`">
        <v-card class="p-2 m-2">
          <v-skeleton-loader type="heading" class="mb-3"></v-skeleton-loader>
          <v-skeleton-loader class="rounded" width="100%" type="table-tbody"></v-skeleton-loader>
        </v-card>
      </v-flex>
    </v-flex>
  </div>
</template>
<script>
import local_numbers from "@/helpers/filters/local_numbers";
import StatWidget from "../../cards/widgets/StatWidget";
import { mapGetters, mapActions } from "vuex";

export default {
  components: { StatWidget },
  filters: { local_numbers },
  data: () => ({
    dailyStats: [],
    previousDailyStats: [],
    topInfluencers: [],
    topBusinesses: [],
    isLoading: true
  }),
  computed: {
    ...mapGetters("core/auth", ["isModerator"]),
    formattedData() {
      let final = { clicks: [], unique_clicks: [], sales: [], revenue: [], commission: [] };
      this.dailyStats.forEach(item => {
        let dateTime = this.$moment.utc(item.date, "YYYY-MM-DD");
        final.clicks.push([dateTime.format(), item.clicks]);
        final.unique_clicks.push([dateTime.format(), item.unique_clicks]);
        final.sales.push([dateTime.format(), item.sales]);
        final.revenue.push([dateTime.format(), item.value]);
        final.commission.push([dateTime.format(), item.commission]);
      });
      return final;
    },
    formattedPreviousData() {
      let final = { clicks: [], unique_clicks: [], sales: [], revenue: [], commission: [] };
      this.previousDailyStats.forEach(item => {
        let dateTime = this.$moment.utc(item.date, "YYYY-MM-DD");
        final.clicks.push([dateTime.format(), item.clicks]);
        final.unique_clicks.push([dateTime.format(), item.unique_clicks]);
        final.sales.push([dateTime.format(), item.sales]);
        final.revenue.push([dateTime.format(), item.value]);
        final.commission.push([dateTime.format(), item.commission]);
      });
      return final;
    },
    total() {
      let final = { clicks: 0, unique_clicks: 0, sales: 0, revenue: 0, commission: 0, conversion: 0, roi: 0, cpc: 0 };
      this.dailyStats.forEach(function(item) {
        final.clicks += parseInt(item.clicks);
        final.unique_clicks += parseInt(item.unique_clicks);
        final.sales += parseInt(item.sales);
        final.revenue += parseFloat(item.value);
        final.commission += parseFloat(item.commission);
      });
      final.revenue = Math.round(final.revenue * 100) / 100;
      final.commission = Math.round(final.commission * 100) / 100;
      if (final.sales && final.clicks) {
        final.conversion = Math.round((final.sales / final.unique_clicks) * 100 * 100) / 100;
      }
      if (final.commission && final.unique_clicks) {
        final.roi = (Number(final.revenue) - Number(final.commission)) / Number(final.commission);
        final.cpc = Number(final.commission) / Number(final.unique_clicks);
      }
      return final;
    },
    predicted() {
      let daysInMonth = parseInt(this.$moment().daysInMonth());
      let elapsedDays = parseInt(this.$moment().utc().format("DD"));
      return {
        clicks: Math.round(daysInMonth * (this.total.clicks / elapsedDays)),
        unique_clicks: Math.round(daysInMonth * (this.total.unique_clicks / elapsedDays)),
        sales: Math.round(daysInMonth * (this.total.sales / elapsedDays)),
        revenue: Math.round(daysInMonth * (this.total.revenue / elapsedDays)),
        commission: Math.round(daysInMonth * (this.total.commission / elapsedDays))
      };
    }
  },
  methods: {
    ...mapActions("core", ["getStats", "getDashboardBusinessStats", "getDashboardInfluencerStats"]),
    getDailyStats() {
      const start = this.$moment().startOf("month").format("YYYY-MM-DD");
      const end = this.$moment().utc().format("YYYY-MM-DD");
      this.getStats({ start_date: start, end_date: end, group: ["date"] }).then(stats => {
        this.dailyStats = stats;
        this.isLoading = false;
      });
      const lastYearStart = this.$moment().utc().startOf("month").subtract(12, "month").format("YYYY-MM-DD");
      const lastYearEnd = this.$moment().utc().subtract(12, "month").format("YYYY-MM-DD");
      this.getStats({ start_date: lastYearStart, end_date: lastYearEnd, group: ["date"] }).then(response => {
        this.previousDailyStats = response;
      });
    },
    getTopInfluencers() {
      const start = this.$moment().utc().startOf("month").format("YYYY-MM-DD");
      const end = this.$moment().utc().format("YYYY-MM-DD");
      this.getDashboardInfluencerStats({ start_date: start, end_date: end, group: ["influencer"], order: ["conversions", "clicks"], limit: 10 }).then(response => {
        this.topInfluencers = (response.data || []).slice().sort((a, b) => (b.sales - a.sales) || (b.clicks - a.clicks));
      });
    },
    getTopBusinesses() {
      const start = this.$moment().utc().startOf("month").format("YYYY-MM-DD");
      const end = this.$moment().utc().format("YYYY-MM-DD");
      this.getDashboardBusinessStats({ start_date: start, end_date: end, group: ["business"], order: ["conversions"], limit: 10 }).then(response => {
        this.topBusinesses = (response.data || []).slice().sort((a, b) => (b.sales - a.sales) || (b.clicks - a.clicks));
      });
    }
  },
  mounted() {
    this.getDailyStats();
    this.getTopInfluencers();
    this.getTopBusinesses();
  }
};
</script>